

import Vue from 'vue'
import Component from "vue-class-component";
import {Prop, VModel, Watch} from "vue-property-decorator";
import {IOnOffHandlers} from "bonomo/dist";
import {namespace} from "vuex-class";
import {IErrors} from "@/model/IErrors";
import {ICourier, ICourierForm} from "@/model/Courier/courierInterfaces";
import ImageUploader from "@/components/shared/ImageUploader.vue";

const courierModule = namespace("courierModule");

const CODE_PATTERN = /^[a-z0-9]+(_[a-z0-9]+)*$/;

@Component({
  components: {ImageUploader},
})
export default class CourierEditDialog extends Vue {

  @VModel()
  protected showing!: boolean;

  @Prop({default: null})
  protected courier!: ICourier|null;

  @courierModule.Getter('errors')
  protected errors!: IErrors;

  // after creating, the dialog stays open on the new courier so a logo can be uploaded
  protected currentCourier: ICourier|null = null;
  protected form: ICourierForm = {code: '', name: '', active: true};
  protected submitting: boolean = false;
  private subscribes: IOnOffHandlers = {};

  protected get logoEndpoint(): string {
    return `settings/couriers/${this.currentCourier!.id}/logo`;
  }

  protected get canSubmit(): boolean {
    return !this.submitting && !!this.form.name.trim() && CODE_PATTERN.test(this.form.code);
  }

  protected codeRule(value: string): boolean|string {
    return !value || CODE_PATTERN.test(value) || (this.$t('settings.couriers.fields.codeInvalid') as string);
  }

  created() {
    this.subscribes = this.$ons({
      'backend.call.OK.courierSaved': this.onSavedOK,
      'backend.call.KO.courierSaved': this.onSavedKO,
    });
  }
  beforeDestroy() {
    this.$offs(this.subscribes);
  }

  @Watch('showing', {immediate: true})
  protected onShowingChanged(showing: boolean) {
    if (!showing) {
      return;
    }
    this.$store.dispatch('courierModule/errors', {});
    this.currentCourier = this.courier;
    this.form = this.courier
      ? {code: this.courier.code, name: this.courier.name, active: this.courier.active}
      : {code: '', name: '', active: true};
  }

  protected onSubmit() {
    this.submitting = true;
    const courier: ICourierForm = {...this.form, name: this.form.name.trim()};
    if (this.currentCourier) {
      this.$store.dispatch('courierModule/updateCourier', {courierId: this.currentCourier.id, courier});
    }
    else {
      this.$store.dispatch('courierModule/createCourier', {courier});
    }
  }

  protected onClose() {
    this.showing = false;
  }

  protected onLogoChanged(courier: ICourier) {
    this.currentCourier = courier;
    this.$store.commit('courierModule/courierSaved', courier);
  }

  private onSavedOK(courier: ICourier) {
    if (!this.submitting) {
      return;
    }
    this.submitting = false;
    this.$uiBus.emit('success', this.$t('settings.couriers.toastSaved'));
    if (this.currentCourier) {
      this.showing = false;
    }
    else {
      this.currentCourier = courier;
    }
  }
  private onSavedKO() {
    this.submitting = false;
  }
}

